var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseerror(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_close_258103_000000") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DONE_16:9_Profil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profil_2_my_settings_password_change-Copy",
    transform: "translate(-1395.000000, -303.000000)",
    fill: "#ffffff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(820.000000, 288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_close_258103_000000",
    transform: "translate(575.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea7878",
    d: "M9.63725275,1.5975208 L6.21989011,4.76019308 L9.63769231,7.92286536 C9.96736264,8.22946411 9.96736264,8.73730266 9.63769231,9.04436685 L9.48402198,9.18196816 C9.15435165,9.48856691 8.6049011,9.48856691 8.27523077,9.18196816 L4.94501099,6.10349841 L1.61523077,9.19222902 C1.28556044,9.49882777 0.73610989,9.49882777 0.40643956,9.19222902 L0.252769231,9.05462771 C-0.0769010989,8.74802896 -0.0769010989,8.24019041 0.252769231,7.93312622 L3.67013187,4.7600873 L0.252769231,1.59741501 C-0.0769010989,1.29081627 -0.0769010989,0.782977714 0.252769231,0.475913526 L0.40643956,0.338312211 C0.73610989,0.0317134641 1.28556044,0.0317134641 1.61523077,0.338312211 L4.94501099,3.41678197 L8.27479121,0.328051351 C8.60446154,0.0214526035 9.15391209,0.0214526035 9.48358242,0.328051351 L9.63725275,0.465652665 C9.97808791,0.78258632 9.97808791,1.28008997 9.63725275,1.59741501 L9.63725275,1.5975208 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseerror);
export default __webpack_public_path__ + "static/media/closeerror.7f009caedefa5bb60e5d2e7c53dbbce0.svg";
export { ForwardRef as ReactComponent };